import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import afTranslation from "../../public/locales/af/translation.json";
import enTranslation from "../../public/locales/en/translation.json";
import esTranslation from "../../public/locales/es/translation.json";

// Initialize i18next
i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      af: {
        translation: afTranslation,
      },
      en: {
        translation: enTranslation,
      },
      es: {
        translation: esTranslation,
      },
    },
    lng: "en", // Default language (will be overridden by user preference)
    fallbackLng: process.env.NODE_ENV === "production" ? "en" : false, // Disable fallback in dev to catch missing translations
    debug: process.env.NODE_ENV === "development", // Enable debug in development

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // In development, return the key itself to make missing translations obvious
    // In production, fall back to the key gracefully
    returnEmptyString: false,
    returnNull: false,

    // Log and throw errors for missing translations in development
    saveMissing: process.env.NODE_ENV === "development",
    missingKeyHandler: (lngs, ns, key) => {
      if (process.env.NODE_ENV === "development") {
        const errorMsg = `❌ MISSING TRANSLATION KEY: "${key}" for languages: [${lngs.join(
          ", "
        )}]`;
        console.error(errorMsg);
        // Throw an error to make it very obvious in the browser console
        throw new Error(errorMsg);
      }
    },
  });

export default i18n;
